import { useSelector } from 'react-redux';
import UtilObject from '../utils/UtilObject';
import { useLocation, Navigate } from 'react-router-dom';
import { getLocalizedPath } from '../i18nLanguages';
import UtilPermission from '../utils/UtilPermission';

const ProtectedRoute = ({ children, permission }) => {
  const location = useLocation();

  const currentUser = useSelector((state) => state.currentUser);

  const isEmpty = UtilObject.isEmpty(currentUser);

  if (isEmpty) {
    return (
      <Navigate
        to={getLocalizedPath('/login', location.pathname)}
        state={{ from: location }}
        replace
      />
    );
  }

  // Sending an unauthorized user back to the dashboard keeps the address bar
  // from becoming a way around the filtered menu.
  if (permission && !UtilPermission.hasPermission(permission, currentUser)) {
    return (
      <Navigate
        to={getLocalizedPath(
          UtilPermission.getHomePath(currentUser),
          location.pathname
        )}
        replace
      />
    );
  }

  return children;
};

export default ProtectedRoute;
